<div class="dialog-content" mat-dialog-content>
  <div class="dialog-header">
    <h2 mat-dialog-title>Update Profile Picture</h2>
    <button mat-dialog-close mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="upload-container" *ngIf="!_isUpdating && !_error && !_message">
    <div class="preview-container" *ngIf="_previewUrl || _selectedFile">
      <img class="preview-image" alt="Preview" [src]="_previewUrl" />
    </div>
    <div
      class="upload-dropzone"
      [class.drag-over]="_isDragOver"
      (click)="triggerFileInput()"
      (dragover)="onDragOver($event)"
      (drop)="onDrop($event)"
    >
      <input #fileInput accept="image/*" hidden type="file" (change)="onImageFileSelected($event)" />
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <p class="upload-text">Drag and drop an image or click to browse</p>
      <p class="upload-hint">Supported formats: JPG, PNG (Max: 5MB)</p>
    </div>
  </div>

  <div class="dialog-actions" mat-dialog-actions>
    <button mat-dialog-close mat-stroked-button>Cancel</button>
    <button
      color="primary"
      mat-raised-button
      style="display: flex"
      [disabled]="!_selectedFile || _isUpdating"
      (click)="onProfileImageUpload()"
    >
      <div style="display: flex">
        <mat-icon *ngIf="!_isUpdating">upload</mat-icon>
        <mat-spinner *ngIf="_isUpdating" diameter="20"></mat-spinner>
        <span>{{ _isUpdating ? 'Uploading...' : 'Upload Picture' }}</span>
      </div>
    </button>
  </div>

  <mat-error class="error-message" *ngIf="_error">
    {{ _error }}
  </mat-error>

  <div class="success-message" *ngIf="_message">
    {{ _message }}
  </div>
</div>
